<div class="flex size-full flex-col gap-y-8 overflow-y-auto bg-surface-A p-12">
    @for (agent of agents(); track agent.id) {
        <interacta-ai-convo-agent-list-item
            [agent]="agent"
            [showDescription]="true"
            (agentClick)="agentSelected.emit($event)"
        />
    }

    @if (agentsFetching()) {
        <div class="flex justify-center">
            <interacta-loader [size]="'small'" />
        </div>
    }
</div>
